







































































































































































import { Vue, Component, Watch, Ref } from "vue-property-decorator";
import router from "@/router/router";
import { BranchFilter } from "@/data/models/BranchFilter";

import ProjectOverviewComponent from "./SimpleProjectOverview.vue";
import MenuIconWithSelectionListComponent from "@/components/common/FilterMenu.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { ProjectDetailsModule } from "@/store/modules/ProjectDetailsModule";

import {
  DryingProjectOverview,
  calculateDryingProgressPercent,
} from "@/data/models/DryingProjectOverview";

import LeakDetectionProjectOverview from "@/data/models/LeakDetectionProjectOverview";
import SelectProjectTypeComponent from "@/components/project/type/SelectProjectType.vue";
import BranchFilterSelectorComponent from "@/components/common/BranchFilterSelector.vue";

import {
  observeFinishedDryingProjects,
  observeRecentlyFinishedDryingProjects,
  observeRunningDryingProjects,
  observeFinishedLeakDetectionProjects,
  observeRecentlyFinishedLeakDetectionProjects,
  observeRunningLeakDetectionProjects,
} from "@/data/repository/ProjectOverviewRepository";

import { StateChanger } from "vue-infinite-loading";
import InfiniteLoading from "vue-infinite-loading";
import {
  doesClientHaveApp,
  findBranch,
  getBranchesOfClient,
  getClientId,
  getProjectManagement,
  getTargetAppVersion,
  hasClientEnabledStrictBranchFilters,
} from "@/data/repository/ClientRepository";

import {
  getNumber,
  setNumber,
  getBoolean,
  setBoolean,
  getString,
  setString,
} from "@/utils/SecureLocalStorage";

import { ProjectsModule } from "@/store/modules/ProjectsModule";
import { UserModule } from "@/store/modules/UserModule";
import ProjectListFilter from "@/assets/icons/ic_sort_projects.svg";
import {
  ProjectFilter,
  doesProjectMatchFilter,
  getFilterName,
} from "@/data/models/ProjectFilter";

import {
  getActiveUser,
  getDefaultBranchFilterOfUser,
} from "@/data/repository/UserRepository";
import { NewProjectScope } from "@/data/repository/ProjectRepository";
import { UserLookup } from "@/data/models/UserLookup";
import {
  ProjectStateFilter,
  ProjectStateFilterType,
} from "@/utils/ProjectStateFilter";
import {
  getLastestProjectState,
  getProjectOverviewUrgencyValue,
  getProjectStateNumber,
} from "@/data/models/ProjectState";
import ProjectOverview from "@/data/models/ProjectOverview";
import { ProjectStateFilterCounter } from "@/utils/ProjectStateFilterCounter";
import {
  CockpitCardType,
  getCockpitCardName,
} from "@/data/models/CockpitCardType";
import { ProjectManagement } from "@/data/models/Client";
import User from "@/data/models/User";

import { ProjectSortOrder } from "@/data/models/ProjectSortOrder";
import { getBranchName } from "@/data/models/Branch";
import { seeAllProjectsAccess, createProjectAccess } from "@/permissions/UserPermissions";
import { FinishedProjectsSettingsModule } from "@/store/modules/FinishedProjectsSettingsModule";
import { firestore } from "firebase";
import { getIresClientType, IresClientType } from "@/data/models/IresClient";
import { calculateBackgroundStyle, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import { ProjectManagementSettingsModule } from "@/store/modules/ProjectManagementSettingsModule";
import { getProjectSettingsV2 } from "@/data/models/Settings";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { getDefaultProjectTypes, ProjectTypeConfig } from "@/data/models/ProjectDetails";
import ToolbarOverflowItemComponent from "@/components/common/ToolbarOverflowItem.vue";
import { getEffectiveUser } from "@/utils/ViewAs";
import { getStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  name: "ProjectsComponent",
  components: {
    "toolbar-overflow-item": ToolbarOverflowItemComponent,
    "project-overview": ProjectOverviewComponent,
    "infinite-loading": InfiniteLoading,
    "project-list-filter": ProjectListFilter,
    "menu-icon": MenuIconWithSelectionListComponent,
    "select-project-type": SelectProjectTypeComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
  },
})
export default class ProjectsComponent extends Vue {
  showProjectStatus = false;

  componentActive = false;
  isProjectsTab = router.currentRoute.query["isProjectsTab"] ?? "true";

  searchQuery = "";
  showProjects = false;

  infiniteId = new Date();
  windowWidth = 0;

  cockpitCardType: CockpitCardType | null = null;

  projectsMatchingSearchQuery: Array<
    DryingProjectOverview | LeakDetectionProjectOverview
  > = [];

  pageSize = 20;
  sliceLength = this.pageSize;

  searchTimeout: NodeJS.Timeout | null = null;

  showFinishedProjects = false;
  isObservingFinishedProjects = false;

  projectStateFilter: ProjectStateFilter | null = null;

  selectedSortOrderBeforeObservingFinishedProjects =
    ProjectSortOrder.NEWEST_FIRST;
  selectedSortOrder = ProjectSortOrder.NEWEST_FIRST;

  sortOrders = [
    ProjectSortOrder.NEWEST_FIRST,
    ProjectSortOrder.OLDEST_FIRST,
    ProjectSortOrder.DRYING_END_OVERDUE_FIRST,
    ProjectSortOrder.URGENCY,
    ProjectSortOrder.PROJECT_PROGRESS,
    ProjectSortOrder.PROJECT_NUMBER,
  ];

  selectedFilter = ProjectFilter.ALL_PROJECTS;
  allFilters = [
    ProjectFilter.ALL_PROJECTS,
    ProjectFilter.PROJECTS_WITH_ONGOING_DRYING,
    ProjectFilter.PROJECTS_WITH_DEVICES_OR_FINISHED_PROJECTS,
    ProjectFilter.OVERDUE_PROJECTS_OR_PROJECTS_MOVED_TO_FINISHED,
    ProjectFilter.RECENTLY_FINISHED_PROJECTS_OR_RESTORED_PROJECTS,
  ];

  ignoreUserRequirements = false;
  branchesOfClient = getBranchesOfClient();
  selectedBranchFilter = getDefaultBranchFilterOfUser();

  subscriptions: Array<() => void> = [];

  /**
   * Kept apart from `subscriptions` because these listeners are replaced when
   * the recently-finished cut-off changes (see `observeRecentProjects`).
   */
  recentProjectsSubscriptions: Array<() => void> = [];

  storageKeyShowFinishedProjects = "storageKeyShowFinishedProjects";
  storageKeySortOrder = "storageKeySortOrderProjects";
  storageKeyFilter = "storageKeyFilterProjects";
  storageKeySliceLength = "projectsListStorageKeySliceLength";
  storageKeyBranchFilter = "storageKeyBranchFilter";

  showToolbarContent = false;
  targetUser: User | null = null;

  isLoading = false;

  showingSuccessSnackbar = false;
  successSnackbarText = "";
  successSnackbarParameters: string[] = [];

  snackbarTimeout = 5000;

  @Ref("searchFieldDesktop") readonly searchFieldDesktop!: Vue;
  @Ref("searchFieldMobile") readonly searchFieldMobile!: Vue;

  @Watch("$i18n.locale")
  onLangugageChanged() {
    this.updateToolbarTitle();
  }

  @Watch("recentlyFinishedProjectsThreshold")
  onRecentlyFinishedProjectsThresholdChanged() {
    if (!this.isObservingFinishedProjects) {
      this.observeRecentProjects();
    }  
  } 

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  /** The user whose view this shows: the chosen one while "Sicht auf" is active (ticket 2610052). */
  get activeUser() {
    return getEffectiveUser();
  }

  get allProjectsFilterName() {
    return this.$t("projectList.filterAllProjects").toString();
  }

  get recentlyFinishedProjectsThreshold() {
    return FinishedProjectsSettingsModule.finishedProjectsSettings.recentlyFinishedProjects;
  }
  
  get unfilteredProjectTypes() {
    const fromStore = this.projectManagementSettings;
    const loaded: ProjectTypeConfig[] | undefined = fromStore && fromStore.projectTypes;
    const base = JSON.parse(JSON.stringify(getDefaultProjectTypes())) as ProjectTypeConfig[];

    if (loaded && Array.isArray(loaded)) {
      const map = new Map<number, ProjectTypeConfig>(loaded.map(p => [p.projectTypeId, p]));
      return base.map(p => {
        const saved = map.get(p.projectTypeId);
        return saved ? { ...p, ...saved } : p;
      });
    } else {
      return base;
    }
  }

  getAllFiltersName() {
    let filtersName = "";
    
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const cockpitCardName = getCockpitCardName(this, this.cockpitCardType!!);
    filtersName += cockpitCardName;

    const projectStateFilter = this.projectStateFilter;
    const isProjectsTab = this.isProjectsTab === "true";

    if (projectStateFilter && !isProjectsTab) {
      const mainFilterName = new ProjectStateFilterCounter(
          projectStateFilter.filterType
        ).getDescription(this);
      
      if (mainFilterName !== this.allProjectsFilterName) {
        filtersName += ", " + mainFilterName;
      }  
    }
    
    const selectedFilterName = this.getProjectFilterName(this.selectedFilter);
    if (selectedFilterName !== this.allProjectsFilterName) {
      filtersName += ", " + selectedFilterName;
    }

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += ", " + selectedBranchFilterName;
    }

    return filtersName;
  }

  getSortOrderName(sortOrder: ProjectSortOrder) {
    switch (sortOrder) {
      case ProjectSortOrder.NEWEST_FIRST:
        return this.$t("projectList.newestProjets");
      case ProjectSortOrder.OLDEST_FIRST:
        return this.$t("projectList.oldestProjects");
      case ProjectSortOrder.DRYING_END_OVERDUE_FIRST:
        return this.$t("projectList.overdueProjects");
      case ProjectSortOrder.URGENCY:
        return this.$t("projectList.urgency");
      case ProjectSortOrder.PROJECT_PROGRESS:
        return this.$t("projectList.projectProgress");
      case ProjectSortOrder.PROJECT_NUMBER:
        return this.$t("projectList.projectNumber");
    }
  }

  getProjectFilterName(projectFilter: ProjectFilter) {
    return getFilterName(this, projectFilter, this.showFinishedProjects);
  }

  showSuccessSnackbar(
    message: string, 
    ...parameters: string[]
  ) {
    this.showingSuccessSnackbar = true;
    this.successSnackbarText = message;
    this.successSnackbarParameters = parameters;
  }

  @Ref("selectProjectType")
  selectProjectType!: SelectProjectTypeComponent;

  @Watch("selectedSortOrder")
  onSortOrderChanged() {
    this.updateToolbarTitle();
  }

  @Watch("selectedFilter")
  onFilterChanged() {
    this.resetDisplayedProjects();
    this.updateToolbarTitle();
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged() {
    this.resetDisplayedProjects();
  }

  get sortOrderMenuIconRes() {
    return "mdi-sort-alphabetical-variant";
  }

  get projectFilterIconRes() {
    return "mdi-filter-variant";
  }

  get canSeeAllProjects() {
    return seeAllProjectsAccess(this.activeUser);
  }

  updateToolbarTitle() {
    const projectStateFilter = this.projectStateFilter;

    const isProjectsTab = this.isProjectsTab === "true";

    const mainFilterName = projectStateFilter && !isProjectsTab
      ? new ProjectStateFilterCounter(
          projectStateFilter.filterType
        ).getDescription(this)
      : this.getProjectFilterName(this.selectedFilter);

    const prefix = this.showFinishedProjects
      ? this.$t("projectList.finishedProjects").toString()
      : this.cockpitCardType && !isProjectsTab
        ? getCockpitCardName(this, this.cockpitCardType)
        : this.canSeeAllProjects
          ? this.$t("projectList.title").toString()
          : this.$t("projectList.relevantProjectsTitle").toString();

    const selectedFilterName = this.getProjectFilterName(this.selectedFilter);
    
    const projectsString = 
      mainFilterName !== this.allProjectsFilterName ?
      (
        selectedFilterName !== this.allProjectsFilterName && mainFilterName !== selectedFilterName ?
        `${prefix} (${mainFilterName}) (${selectedFilterName})` :
        `${prefix} (${mainFilterName})`
      ) :
      (
        selectedFilterName !== this.allProjectsFilterName ?
        `${prefix} (${selectedFilterName})` :
        `${prefix}`
      );

    // No "(Sicht <name>)" here: the Sicht auf chip beside the title names them (ticket 2610050).
    ToolbarContentModule.setToolbarTitle(projectsString);
  }

  activated() {
    const deletedProjectName = getString("KEY_DELETED_PROJECT_NAME");
    
    if (deletedProjectName) {
      setString("KEY_DELETED_PROJECT_NAME");
      this.showSuccessSnackbar("clientData.deleteProjectSuccessMessage", deletedProjectName);
    } 

    const branchIdQuery = getStoredBranchFilterId("branchFilter");

    if (branchIdQuery) {
      const matchingBranch = findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    this.componentActive = true;
    this.updateToolbarTitle();
    this.focusSearchFieldIfNeeded();
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    this.componentActive = true;
    this.updateToolbarTitle();
    this.onWindowsResize();
    this.focusSearchFieldIfNeeded();
  }

  reloadProjectsList() {
    if (this.searchQuery && this.searchQuery !== "") {
      this.processSearchQuery(this.searchQuery);
    }
  }

  @Watch("runningDryingProjects")
  onRuningDryingProjectsChanged() {
    this.reloadProjectsList();
  }

  @Watch("finishedDryingProjects")
  onFinishedDryingProjectsChanged() {
    this.reloadProjectsList();
  }

  @Watch("recentlyFinishedDryingProjects")
  onRecentlyFinishedDryingProjectsChanged() {
    this.reloadProjectsList();
  }

  @Watch("runningLeakDetectionProjects")
  onRunningLeakDetectionProjectsChanged() {
    this.reloadProjectsList();
  }

  @Watch("finishedLeakDetectionProjects")
  onFinishedLeakDetectionProjectsChanged() {
    this.reloadProjectsList();
  }

  @Watch("recentlyFinishedLeakDetectionProjects")
  onRecentlyFinishedLeakDetectionProjectsChanged() {
    this.reloadProjectsList();
  }

  get runningDryingProjects() {
    return ProjectsModule.runningDryingProjects;
  }

  get finishedDryingProjects() {
    return ProjectsModule.finishedDryingProjects;
  }

  get recentlyFinishedDryingProjects() {
    return ProjectsModule.recentlyFinishedDryingProjects;
  }

  get runningLeakDetectionProjects() {
    return ProjectsModule.runningLeakDetectionProjects;
  }

  get finishedLeakDetectionProjects() {
    return ProjectsModule.finishedLeakDetectionProjects;
  }

  get recentlyFinishedLeakDetectionProjects() {
    return ProjectsModule.recentlyFinishedLeakDetectionProjects;
  }

  get users() {
    return UserModule.users;
  }

  get userLookup() {
    return new UserLookup(this.users);
  }

  selectSortOrder(selectedSortOrder: ProjectSortOrder) {
    if (selectedSortOrder === this.selectedSortOrder) {
      return;
    }

    this.selectedSortOrder = selectedSortOrder;
    this.resetDisplayedProjects();
  }

  toggleShowFinishedProjects() {
    this.isLoading = true;
    if (!this.showFinishedProjects && !this.isObservingFinishedProjects) {
      this.observeFinishedProjects();
      this.isObservingFinishedProjects = true;
    }

    this.showFinishedProjects = !this.showFinishedProjects;

    if (this.showFinishedProjects) {
      this.selectedSortOrderBeforeObservingFinishedProjects =
        this.selectedSortOrder;
      // We want the same sort order for the finished/current projects
      //this.selectedSortOrder = ProjectSortOrder.PROJECT_PROGRESS;
    } else {
      this.selectedSortOrder =
        this.selectedSortOrderBeforeObservingFinishedProjects;
    }

    if (this.searchQuery) {
      this.processSearchQuery(this.searchQuery);
    } else {
      this.resetDisplayedProjects();
    }

    this.updateToolbarTitle();
    
    if (this.projectsToDisplay.length === 0) {
      setTimeout(() => {
        this.isLoading = false;
      }, 400);
    }
    else {
      this.isLoading = false;
    }
  }

  async created() {
    this.isLoading = true;
    const activeUser = this.activeUser;
    this.showProjectStatus = doesClientHaveApp();

    this.observeRecentProjects();

    await new Promise((resolve) => setTimeout(resolve, 100));

    const cockpitCardType = router.currentRoute.query[
      "cockpitCardType"
    ] as string;

    if (cockpitCardType) {
      this.cockpitCardType = Number.parseInt(cockpitCardType);
    }
    else {
      if (this.canSeeAllProjects) {
        this.ignoreUserRequirements = true;
        this.cockpitCardType = Number.parseInt("4");
      }
      else {
        this.cockpitCardType = Number.parseInt("3");
      }
    }

    const ignoreUserRequirementsQuery = router.currentRoute.query[
      "ignoreUserRequirements"
    ] as string;

    if (ignoreUserRequirementsQuery) {
      this.ignoreUserRequirements = true;
    }

    // "Sicht auf" is one choice for the whole app (ticket 2610050); Scaffold re-creates the page when
    // it changes, so reading it once here is enough.
    this.targetUser = activeUser;

    const projectStateFilterTypeQuery =
      router.currentRoute.query["projectStateFilterType"] ?
      router.currentRoute.query["projectStateFilterType"] :
      "OVERALL";

    if (projectStateFilterTypeQuery) {
      this.projectStateFilter = new ProjectStateFilter(
        projectStateFilterTypeQuery as ProjectStateFilterType
      );
    }

    const sortOrderQuery = router.currentRoute.query["sortOrder"];

    if (sortOrderQuery) {
      this.selectedSortOrder = Number.parseInt(sortOrderQuery as string);
    } else {
      const cachedSortOrder = getNumber(this.storageKeySortOrder);

      if (cachedSortOrder != null) {
        this.selectedSortOrder = cachedSortOrder;
      }
    }

    const cachedShowFinishedProjects = getBoolean(
      this.storageKeyShowFinishedProjects
    );

    if (cachedShowFinishedProjects) {
      this.toggleShowFinishedProjects();
    }

    const cachedSliceLength = getNumber(this.storageKeySliceLength);
    if (cachedSliceLength) {
      this.sliceLength = cachedSliceLength;
      setNumber(this.storageKeySliceLength);
    }

    this.updateToolbarTitle();

    this.isLoading = false;
  }

  get showLeakDetectionProjects() {
    return (
      doesClientHaveApp() || this.testingAccounts.indexOf(getClientId()) >= 0
    );
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription();
    });

    this.recentProjectsSubscriptions.forEach((subscription) => {
      subscription();
    });

    setBoolean(this.storageKeyShowFinishedProjects, this.showFinishedProjects);
    setNumber(this.storageKeyFilter, this.selectedFilter);
    setNumber(this.storageKeySortOrder, this.selectedSortOrder);
  }

  /**
   * Observes the running projects plus the recently finished ones, the latter
   * with a cut-off date derived from the client's finished-projects setting.
   *
   * Called again when that setting arrives, so the previous listeners must be
   * disposed first: otherwise two sets of listeners with different cut-off
   * dates stay alive and overwrite each other's store data on every snapshot,
   * which makes the project count flip between two values.
   */
  observeRecentProjects() {
    this.recentProjectsSubscriptions.forEach((subscription) => {
      subscription();
    });

    this.recentProjectsSubscriptions = [
      observeRunningDryingProjects(),
      observeRecentlyFinishedDryingProjects(this.recentlyFinishedProjectsThreshold),
    ];

    if (this.showLeakDetectionProjects) {
      this.recentProjectsSubscriptions.push(observeRunningLeakDetectionProjects());
      this.recentProjectsSubscriptions.push(
        observeRecentlyFinishedLeakDetectionProjects(this.recentlyFinishedProjectsThreshold)
      );
    }
  }

  testingAccounts = [
    "NOJ70KBpZsS9PqU6wOJlNERvFlU2",
    "sfztT2VTtAeNOpcgmdWuIQea4Ve2",
  ];

  observeFinishedProjects() {
    this.subscriptions.push(observeFinishedDryingProjects());

    if (this.showLeakDetectionProjects) {
      this.subscriptions.push(observeFinishedLeakDetectionProjects());
    }
  }

  get showInfiniteLoading() {
    return this.sortedProjects.length > 0;
  }

  get projectsToDisplay() {
    return this.sliceProjectsToDisplay(this.sliceLength);
  }

  get numberOfProjects() {
    if (this.searchQuery) {
      return this.projectsMatchingSearchQuery.length;
    } else {
      return this.sortedProjects.length;
    } 
  }

  sliceProjectsToDisplay(length: number) {
    let update;

    if (this.searchQuery) {
      update = this.projectsMatchingSearchQuery;
    } else {
      update = this.sortedProjects;
    }

    return update.slice(0, length);
  }

  onWindowsResize() {
    this.windowWidth = window.innerWidth;
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = this.sliceProjectsToDisplay(nextSliceLength);

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  doesProjectMatchFilter(
    filter: ProjectFilter,
    projectOverview: DryingProjectOverview | LeakDetectionProjectOverview
  ) {
    return doesProjectMatchFilter(
      filter,
      projectOverview,
      this.recentlyFinishedProjectsThreshold,
      this.showFinishedProjects
    );
  }

  get isSanTecClient() {
    return getIresClientType(getClientId()) === IresClientType.SanTec;
  }

  get sortedProjects(): Array<
    DryingProjectOverview | LeakDetectionProjectOverview
  > {
    const user = this.targetUser ?? getActiveUser();

    const finishedDryingProjects = this.finishedDryingProjects;

    const finishedLeakDetectionProjects = this.finishedLeakDetectionProjects;

    const recentDryingProjects = [
      ...this.runningDryingProjects,
      ...this.recentlyFinishedDryingProjects,
    ];

    const recentLeakDetectionProjects = [
      ...this.runningLeakDetectionProjects,
      ...this.recentlyFinishedLeakDetectionProjects,
    ];

    const toSort: Array<DryingProjectOverview | LeakDetectionProjectOverview> =
      this.showFinishedProjects
        ? [...finishedDryingProjects, ...finishedLeakDetectionProjects]
        : [...recentDryingProjects, ...recentLeakDetectionProjects];

    const filter = this.selectedFilter;
    const branchFilter = this.selectedBranchFilter;

    const userLookup = this.userLookup;

    if (!userLookup) {
      return [];
    }

    const today = new Date();

    const sorted = toSort
      .filter((p) => !!p.id)
      .map((projectOverview) => {
        const projectState = getLastestProjectState(projectOverview, today);

        return {
          projectOverview: projectOverview,
          latestProjectState: projectState,
          projectProgress: projectState
            ? getProjectStateNumber(projectState)
            : 1000,
          urgencySortValue: getProjectOverviewUrgencyValue(
            projectOverview,
            projectState
          ),
        };
      })
      .sort((data1, data2) => {
        if (
          this.selectedSortOrder == ProjectSortOrder.DRYING_END_OVERDUE_FIRST
        ) {
          const percentage1 = calculateDryingProgressPercent(
            data1.projectOverview
          );
          const percentage2 = calculateDryingProgressPercent(
            data2.projectOverview
          );

          if (percentage1 == percentage2) {
            return (
              data1.projectOverview.projectNumberIres ?? ""
            ).localeCompare(data2.projectOverview.projectNumberIres ?? "");
          } else {
            return percentage2 - percentage1;
          }
        } else if (this.selectedSortOrder == ProjectSortOrder.PROJECT_NUMBER) {
          return (data2.projectOverview.projectNumberIres ?? "").localeCompare(
            data1.projectOverview.projectNumberIres ?? ""
          );
        } else if (this.selectedSortOrder == ProjectSortOrder.URGENCY) {
          if (data1.urgencySortValue > data2.urgencySortValue) {
            return 1;
          } else if (data1.urgencySortValue === data2.urgencySortValue) {
            return 0;
          } else {
            return -1;
          }
        }

        if (this.selectedSortOrder == ProjectSortOrder.PROJECT_PROGRESS) {
          if (data1.projectProgress != data2.projectProgress) {
            return data1.projectProgress - data2.projectProgress;
          } else if (data1.urgencySortValue > data2.urgencySortValue) {
            return -1;
          } else if (data1.urgencySortValue === data2.urgencySortValue) {
            return 0;
          } else {
            return 1;
          }
        }

        const p1 = data1.projectOverview;
        const p2 = data2.projectOverview;

        const isSanTec = this.isSanTecClient;
        
        const projectStartDate1ForSanTec = firestore.Timestamp.fromDate(new Date(((p1 as DryingProjectOverview).dryingProjectSteps?.projectAccepted?.creationTimestamp)));
        const projectStartDate2ForSanTec = firestore.Timestamp.fromDate(new Date(((p2 as DryingProjectOverview).dryingProjectSteps?.projectAccepted?.creationTimestamp)));
        
        const isProjectStartDate1ForSanTecValid = 
          projectStartDate1ForSanTec && 
          projectStartDate1ForSanTec.toMillis() < p1.startDate?.toMillis();
        const isProjectStartDate2ForSanTecValid = 
          projectStartDate2ForSanTec && 
          projectStartDate2ForSanTec.toMillis() < p2.startDate?.toMillis();

        const date1ToBeCompared = isSanTec && isProjectStartDate1ForSanTecValid 
          ? projectStartDate1ForSanTec 
          : p1.startDate;
        const date2ToBeCompared = isSanTec && isProjectStartDate2ForSanTecValid 
          ? projectStartDate2ForSanTec 
          : p2.startDate;

        if (!date2ToBeCompared) {
          return 1;
        }
        else if (!date1ToBeCompared) {
          return -1;
        }

        let startDateDiff = date2ToBeCompared.seconds - date1ToBeCompared.seconds;

        if (startDateDiff === 0) {
          startDateDiff = p1.projectName.localeCompare(p2.projectName);
        }

        if (startDateDiff === 0) {
          startDateDiff = (p2.projectNumber ?? "").localeCompare(
            p1.projectNumber ?? ""
          );
        }

        if (this.selectedSortOrder === ProjectSortOrder.NEWEST_FIRST) {
          return startDateDiff;
        } else if (this.selectedSortOrder === ProjectSortOrder.OLDEST_FIRST) {
          return -startDateDiff;
        } else {
          let dryingProgressP1 = calculateDryingProgressPercent(p1);
          let dryingProgressP2 = calculateDryingProgressPercent(p2);

          if (p1.endDate) {
            dryingProgressP1 = 0;
          }

          if (p2.endDate) {
            dryingProgressP2 = 0;
          }

          if (dryingProgressP1 == dryingProgressP2) {
            return startDateDiff;
          } else if (dryingProgressP1 > dryingProgressP2) {
            return -1;
          } else {
            return 1;
          }
        }
      })
      .map((data) => data.projectOverview);

    if (sorted && sorted.length > 0) {
      this.showProjects = true;
    }

    return sorted.filter(
      (projectOverview) =>
        branchFilter.doesProjectOverviewMatchFilter(projectOverview) &&
        (
          (
            this.projectStateFilter?.matchesProjectOverview(
              projectOverview,
              user,
              userLookup,
              today,
              {
                ignoreUserRequirements: this.ignoreUserRequirements,
                log: projectOverview.projectName?.endsWith("482"),
              }
            ) &&
            this.doesProjectMatchFilter(filter, projectOverview)
          ) ??
          this.doesProjectMatchFilter(filter, projectOverview)
        )
    );
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }

  processSearchQuery(newQuery: string) {
    const filter = this.selectedFilter;
    const branchFilter = this.selectedBranchFilter;
    const searchQueryUpperCase = newQuery.toUpperCase();

    this.projectsMatchingSearchQuery = this.sortedProjects.filter(
      (projectOverview) =>
        branchFilter.doesProjectOverviewMatchFilter(projectOverview) &&
        this.doesProjectMatchFilter(filter, projectOverview) &&
        ((projectOverview.projectName && projectOverview.projectName
          .toUpperCase()
          .includes(searchQueryUpperCase)) ||
          projectOverview.projectNumber
            .toUpperCase()
            .includes(searchQueryUpperCase) ||
          (projectOverview.projectNumberIres && 
            projectOverview.projectNumberIres
              .toUpperCase()
              .includes(searchQueryUpperCase)) ||
          (projectOverview.projectNameErp &&
            projectOverview.projectNameErp
              .toUpperCase()
              .includes(searchQueryUpperCase)) ||
          projectOverview.id === newQuery)
    );

    this.searchQuery = newQuery;
    this.resetDisplayedProjects();
  }

  resetDisplayedProjects() {
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  clearSearchQuery() {
    this.searchQuery = "";
    this.resetDisplayedProjects();
  }

  focusSearchFieldIfNeeded() {
    if (!this.searchQuery) {
      return;
    }

    this.$nextTick(() => {
      const isMobile = this.$vuetify.breakpoint.smAndDown;
      const field = isMobile ? this.searchFieldMobile : this.searchFieldDesktop;

      if (!field) {
        return;
      }

      const fieldAny = field as unknown as { focus?: () => void; $el?: HTMLElement };
      if (fieldAny.focus) {
        fieldAny.focus();
      }

      const input = fieldAny.$el?.querySelector("input") as HTMLInputElement | null;
      if (input) {
        input.focus();
        input.select();
      }
    });
  }

  onCreateProject() {
    if (
      !doesClientHaveApp() ||
      getTargetAppVersion() >= 949 ||
      getTargetAppVersion() === 0 ||
      getProjectManagement() === ProjectManagement.WEBSITE
    ) {
      router.push({
        path: "createProject",
        query: {
          newProjectScope: NewProjectScope.FLEX,
        },
      });
    } else {
      this.selectProjectType.show();
    }
  }

  get showProjectsList() {
    return this.userLookup;
  }

  get projectManagementSettings() {
    return ProjectManagementSettingsModule.projectManagementSettings;
  }

  get projectSettings() {
    return getProjectSettingsV2(this.projectManagementSettings);
  }

  get showCreateProjectButton() {
    if (this.showFinishedProjects) {
      return false;
    }

    return createProjectAccess(this.activeUser, this.projectSettings);
  }

  onOpenProjectDetails(projectOverview: ProjectOverview, index: number) {
    ProjectDetailsModule.cacheProjectDetailsState(null);
    const projectId = projectOverview.id;

    const cockpitCardType = this.cockpitCardType;
    const ignoreUserRequirements = this.ignoreUserRequirements;
    const sortOrder = this.selectedSortOrder;
    
    const isProjectsTab = this.isProjectsTab;

    setNumber(
      this.storageKeySliceLength,
      this.pageSize + Math.floor(index / this.pageSize) * this.pageSize
    );

    setLastVisitedItem(
      projectId,
      StorageKeyLastVisitedItemLevel.LEVEL_1,
    );
    
    router.push({
      path: `projects/${projectId}`,
      params: {
        projectId: projectId
      },
      query: {
        cockpitCardType: cockpitCardType?.toString(),
        ignoreUserRequirements: ignoreUserRequirements
          ? ignoreUserRequirements.toString()
          : null,
        sortOrder: (
          sortOrder ?? ProjectSortOrder.NEWEST_FIRST
        ).toString(),
        isProjectsTab: isProjectsTab
      }
    });
  }

  calculateBackgroundStyle(projectId: string) {
    return calculateBackgroundStyle(projectId);
  }

  /** Phone layout (below 600 px): search inside the header card, create as a floating button. */
  get isPhone() {
    return this.$vuetify.breakpoint.xsOnly;
  }

  /**
   * Phones and iPad mini (below 960 px): the search sits inside the sticky header card (the app bar
   * has it from 960 px), and the hint is left out so the + stays beside the count.
   */
  get isCompactHeader() {
    return this.$vuetify.breakpoint.smAndDown;
  }
}
